<template>
  <div v-show="show">
    <header class="header-main_v2"> <!-- v-show="!$route.meta.hideHeader" -->
      <nav class="mobile-menu">
        <div class="menu_v2_contains">
          <div class="logo">
            <router-link  to="/visitor" :class="['logo-header', getActiveTabClass('/visitor')]"> <!-- TODO active tab class -->
              <img :src="logoSrc" @click="updateBM" alt="">
            </router-link>
          </div>
          <button data-menu="dropdown_lang" class="nav__toggle nav__toggle_lang"></button>
          <button data-menu="nav_dropdown_burgerMenu" :class="['nav__toggle nav__toggle_burgerMenu', isIos ? 'ui_desc_ios' : '']"><span></span></button>
          <div class="items">
            <nav class="main-nav">
              <ul v-if="!hideLangSelection" class="main-nav__lang" id="get_started_menu">
                <li class="dropdown">
                  <a><div class="icon-globe"><img src="static/images/icon-globe.svg" alt=""></div></a>
                  <ul>
                    <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                      <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <input type="checkbox" id="checkbox" class="mobile-menu__checkbox">
        <label for="checkbox" class="mobile-menu__btn">
          <div class="mobile-menu__icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </label>
        <div class="mobile-menu__container">
          <ul class="mobile-menu__list">
            <li class="mobile-menu__item"> <!-- WIN INSTANTLY TODO WHAT ABOUT THIS PAGE-->
              <router-link to="/prizes" :class="['mobile-menu__link', getActiveTabClass('/prizes')]">
                {{ getTranslations.home_win_instantly }}
              </router-link>
            </li>
            <li v-if="!hideLeaderboard" class="mobile-menu__item"> <!-- PRIZES & LEADERBOARDS -->
              <router-link to="/home/prizesAndLeaderBoards" :class="['mobile-menu__link', getActiveTabClass('/home/prizesAndLeaderBoards')]">
                {{ getTranslations.home_home_prizes_and_leaderboards_visitor }}
              </router-link>
            </li>
            <li v-if="!hideWinners" class="mobile-menu__item"> <!-- WINNERS -->
              <router-link to="/winners" :class="['mobile-menu__link', getActiveTabClass('/winners')]">
                {{ getTranslations.home_home_winners }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/howItWorks" :class="['mobile-menu__link', getActiveTabClass('/howItWorks')]">
                {{ getTranslations.home_home_how_it_works }}
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <router-view></router-view>
    <footer :class="['footer-main ', getTranslations.visitor_visitor_brought_to_you  ? cookiesPopUpEnabled ? 'with_brand more_links' : 'with_brand' : cookiesPopUpEnabled ? 'with_brand more_links' : '']">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li> <!-- add this li for branded footer -->
              <div class="footer_align"><span>{{ getTranslations.visitor_visitor_brought_to_you }}</span> <img  :src="[getTranslations.project_config_visitor_footer_logo]"></div>
            </li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a></li>
            <li :class="['', getTranslations.visitor_visitor_brought_to_you  ? 'with_brand' : '']"><div class="divider"></div></li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a></li>
            <li v-if="cookiesPopUpEnabled" :class="['', getTranslations.visitor_visitor_brought_to_you  ? 'with_brand' : '']"><div class="divider"></div></li>
            <li v-if="cookiesPopUpEnabled"><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_cookies_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_cookies_policy }}</a></li>

          </ul>
        </nav>
      </div>
    </footer>
    <div class="black-overlay"></div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
    <operator-selection v-if="getSelectOperatorModalChoice()"
                        @close="toggleSelectOperatorModal(false);">
    </operator-selection>

    <div class="row random_waves">
      <div class="col-lg-2">
        <span class="waves wave3"></span>
      </div>
      <div class="col-lg-8"></div>
      <div class="col-lg-2">
        <span class="waves wave4"></span>
      </div>
    </div>

    <div class="black-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import SkinMixin from '@/common/mixins/skin';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import operatorSelection from '@/components/home/modals/OperatorSelectionModal';
import $ from 'jquery';
import { handleLanguageDropdown, handleBurger, openCloseTab } from '../../common/jQuery';


const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'navigation-header',
  mixins: [IntegrationMixin, RegistrationFlowMixin, SkinMixin],
  components: { simplifyRegistration, subVerifyWifi, operatorSelection },
  data() {
    return {
      isIos: false,
      operatorLogoForBrandedProject: '',
      currentTabPath: '',
      showSimpleRegistrationModal: false,
      show: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.hidePage()) vm.showPage(false);
      vm.getIntegration(to);
    });
  },
  created() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.currentTabPath = sessionStorage.getItem('visitorCurrentTabPath');
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator-footer.svg` : '';
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger();
    });
    openCloseTab();
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    this.getIntegration(to);
    this.currentTabPath = to.path;
    sessionStorage.setItem('visitorCurrentTabPath', to.path);
    next();
  },
  methods: {
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapActions('profile', [
      'storeVisitorWinners',
      'storeAvailablePrizeTypes',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    showPage(value) {
      this.show = value;
    },
    getIntegration(to) {
      if (to.path === '/') this.checkForRegisterRedirect(to);
      else this.showPage(true);
    },
    checkForRegisterRedirect(to) {
      this.getIntegrationParametersCheck()(to);
    },
    toCreditsPage() {
      this.$router.push('/credits');
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.facebookSDKApi();
            this.changeCSSFile();
          });
        });
      });
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
    updateBM() {
      $('.mobile-menu__container').removeClass('open');
      $('.mobile-menu__icon').removeClass('open');
    },
  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'hideLangSelection',
      'hidePrizePage',
      'cookiesPopUpEnabled',
      'hideWinners',
      'hideLeaderboard',
      'logoOnFooter',
      'multiOperatorInfo',
      'isBrandedProject',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
      'getTranslations',
    ]),
    logoSrc() {
      return this.getTranslations.logo_for_branded_projects || this.$_skinImage({ fileName: 'logo-brainiac.svg', skins: [100] });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Visitor.vue